var _circle, _mask, _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.075,
    fill: "white",
    stroke: "#202135",
    strokeWidth: 1.85
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_12_2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 30.5C53 35.8236 51.1124 40.9748 47.6726 45.0379C44.2329 49.1011 39.4638 51.8129 34.2132 52.6915C28.9626 53.5701 23.5705 52.5584 18.9955 49.8364C14.4204 47.1143 10.9586 42.8583 9.2256 37.8246C7.49256 32.791 7.60047 27.3059 9.53014 22.3443C11.4598 17.3827 15.0862 13.2661 19.7649 10.7261C24.4435 8.18612 29.8711 7.38733 35.0831 8.47173C40.2952 9.55612 44.9538 12.4535 48.2311 16.6487L46.7667 17.7927C43.7601 13.9439 39.4862 11.2859 34.7046 10.291C29.9231 9.29618 24.9437 10.029 20.6515 12.3592C16.3593 14.6894 13.0323 18.4661 11.262 23.0179C9.49171 27.5697 9.39272 32.6018 10.9826 37.2197C12.5725 41.8376 15.7484 45.7422 19.9456 48.2394C24.1428 50.7366 29.0896 51.6647 33.9066 50.8587C38.7235 50.0527 43.0987 47.5648 46.2543 43.8373C49.41 40.1097 51.1418 35.3839 51.1418 30.5H53Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53 30.5C53 35.8236 51.1124 40.9748 47.6726 45.0379C44.2329 49.1011 39.4638 51.8129 34.2132 52.6915C28.9626 53.5701 23.5705 52.5584 18.9955 49.8364C14.4204 47.1143 10.9586 42.8583 9.2256 37.8246C7.49256 32.791 7.60047 27.3059 9.53014 22.3443C11.4598 17.3827 15.0862 13.2661 19.7649 10.7261C24.4435 8.18612 29.8711 7.38733 35.0831 8.47173C40.2952 9.55612 44.9538 12.4535 48.2311 16.6487L46.7667 17.7927C43.7601 13.9439 39.4862 11.2859 34.7046 10.291C29.9231 9.29618 24.9437 10.029 20.6515 12.3592C16.3593 14.6894 13.0323 18.4661 11.262 23.0179C9.49171 27.5697 9.39272 32.6018 10.9826 37.2197C12.5725 41.8376 15.7484 45.7422 19.9456 48.2394C24.1428 50.7366 29.0896 51.6647 33.9066 50.8587C38.7235 50.0527 43.0987 47.5648 46.2543 43.8373C49.41 40.1097 51.1418 35.3839 51.1418 30.5H53Z",
    fill: "#A75757",
    stroke: "#15B9D9",
    strokeWidth: 3.7,
    mask: "url(#path-2-inside-1_12_2)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: 31.075,
    x2: 53,
    y2: 31.075,
    stroke: "#15B9D9",
    strokeWidth: 1.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.08989a29507d464b431d4b2299372768.svg";
export { ForwardRef as ReactComponent };